<!-- Left Sidebar -->
<aside class="sidebar {{ _util.theme }}" (mouseenter)="_util.hoverCheck = true" (mouseleave)="_util.hoverCheck = false"
  [style.overflow]="displaySecondLevel < 0 ? 'hidden' : 'unset'">
  <a class="h-px-50 d-block position-relative" href="">
    <div class="d-flex justify-content-center align-items-center py-2">
      <img class="h-px-35 w-px-35" src="assets/images/{{ logo }}" alt="">
    </div>
  </a>
  <!-- Menu -->
  <div class="menu">
    <ul class="list" [@flyInOut]="menuType"
      [ngStyle]="{'position' : 'relative', 'min-height' : listMaxHeight+'px', 'max-width' : listMaxWidth+'px'}">
      <li *ngIf="menuType==='settings'" (click)="toggleSideMenu('default')">
        <div class="hoverable-nav-item">
          <a class="menu-top cursor-pointer d-flex align-items-center">
            <!-- <i class="fas fa-long-arrow-alt-left"></i> -->
            <wz-icon [name]="'left-long-solid'" [iconClass]="'icon-18 opacity-arrow'"></wz-icon>
          </a>
        </div>
      </li>
      <!-- Top Most level menu -->
      <div class="left-nav-overflow">
        <ng-container *ngFor="let sidebarItem of sidebarItems; index as i; trackBy: trackBySidebarItem">
          <ng-container  *ngIf="!sidebarItem?.hideInSideNav">
            <li (mouseenter)="displaySecondLevel = i">
              <ng-container>
                <div class="hoverable-nav-item" [class.active]="(level1Menu.name == sidebarItem.moduleName) && (level1Menu.type == sidebarItem.type)"
                (click)="positionCheck(i)">
                <a class="list-icons" [ngClass]="{'light-theme' : _util.theme === 'menu_light'}" *ngIf="sidebarItem.groupTitle;" [ngClass]="[sidebarItem.class]"
                  (click)="callLevel1Toggle()" class="menu-top">
                  <ng-container *ngIf="sidebarItem.type==='default'">
                    <img [ngClass]="'material-icons'" [src]="sidebarItem.iconPath">
                  </ng-container>
                  <ng-container *ngIf="sidebarItem.type==='settings'">
                    <ng-container *ngIf="sidebarItem.iconType === 'wz-custom-icons' ;else iconTemplate">
                      <img [ngClass]="'material-icons'" [src]="sidebarItem.iconPath">
                    </ng-container>
                    <ng-template #iconTemplate>
                      <i [ngClass]="[sidebarItem.iconType]" >{{sidebarItem.icon}}</i>
                    </ng-template>
                  </ng-container>
                  <span *ngIf="sidebarItem.badge != '' " [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
                </a>
                <p class="module-title m-0 text-ellipsis"> {{ (sidebarItem.title && sidebarItem.title.length > 8 ) ? (sidebarItem.title.substring(0, 7)  + '..')  : sidebarItem.title}}</p>
                <!-- <span class="header" *ngIf="sidebarItem.groupTitle === true">
                  {{sidebarItem.title}}
                </span> -->
                  <ng-container *ngIf="sidebarItem.submenu.length > 0">
                    <ng-container *ngIf="displaySecondLevel === i">
                    <div class="active-menu-arrow second-level-arrow"></div>
                    </ng-container>
                    <ul class="sidebar-second-level">
                      <div class="sidebar-levels-header">{{ sidebarItem.title }}</div>
                      <ng-container *ngFor="let secondLevel of sidebarItem.submenu; index as secondLevelIndex; trackBy: trackBySidebarItem">
                        <li class="second-level-list-item ms-1 me-1 position-relative" (click)="panelNavigation(secondLevel.path, secondLevelIndex)"
                          [class.active]="level2Menu === secondLevel.moduleName && level1Menu.name === sidebarItem.moduleName">
                          <img [src]="secondLevel.iconPath" class="icon-18">
                          <h6 class="submenu-title m-0">{{secondLevel.title}}</h6>
                          <ng-container *ngIf="secondLevel.submenu.length > 0">
                            <ul class="third-level-menu">
                              <div class="sidebar-levels-header third-level-header">{{ secondLevel.title }}</div>
                              <div class="active-menu-arrow third-level-arrow"></div>
                              <ng-container *ngFor="let thirdLevel of secondLevel.submenu; index as thirdLevelIndex; trackBy: trackBySidebarItem">
                                <li class="third-level-list-item ms-1 me-1" [class.active]="level3Menu === thirdLevel.moduleName && level2Menu === secondLevel.moduleName"
                                 (click)="panelNavigation(thirdLevel.path, i)">
                                  <img [src]="thirdLevel.iconPath" class="icon-18">
                                  <h6 class="submenu-title m-0">{{thirdLevel.title}}</h6>
                                </li>
                              </ng-container>
                            </ul>
                          </ng-container>
                        </li>
                      </ng-container>
                    </ul>
                  </ng-container>
                   
              </div>
              <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0">
                <li [ngClass]="level2Menu === sidebarSubItem.moduleName? 'activeSub':''"
                  *ngFor="let sidebarSubItem of sidebarItem.submenu; trackBy: trackBySidebarItem"
                  [routerLinkActive]="sidebarSubItem.submenu.length > 0 ? '' : 'active'">
                  <a [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                    (click)="callLevel2Toggle($event,sidebarSubItem.moduleName)" [ngClass]="[sidebarSubItem.class]">
                    {{sidebarSubItem.title}}
                  </a>
                  <!-- Second level menu -->
                  <ul class="ml-menu-2" *ngIf="sidebarSubItem.submenu.length > 0">
                    <li *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu; trackBy: trackBySidebarItem"
                      [ngClass]="level3Menu === sidebarSubsubItem.moduleName? 'activeSubSub':''"
                      [routerLinkActive]="sidebarSubsubItem.submenu.length > 0 ? '' : 'active'">
                      <a [routerLink]="sidebarSubsubItem.submenu.length > 0 ? null : [sidebarSubsubItem.path]"
                        (click)="callLevel3Toggle($event,sidebarSubsubItem.moduleName)"
                        [ngClass]="[sidebarSubsubItem.class]">
                        {{sidebarSubsubItem.title}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              </ng-container>
              <!-- First level menu -->        
            </li>
          </ng-container>
        </ng-container>
        </div>
      <ng-container *ngIf="menuType === 'default'">
        <li class="leftmenu-settings" (click)="toggleSideMenu('settings')" *ngIf="doDisplaySettings()">
          <div class="hoverable-nav-item">
            <a class="menu-top cursor-pointer">
              <img class="settings"
                src="assets/images/icons/{{ _util.theme !== 'menu_dark' ?  _util.theme.split('_')[1] + '-' + 'employee-settings' : 'employee-settings'}}.svg">
            </a>
            <p class="module-title m-0 text-ellipsis">settings</p>
          </div>
        </li>
        <!-- <li class="leftmenu-gear" [class.active]="">
          <div class="hoverable-nav-item">
            <a class="menu-top cursor-pointer">
              <img class="w-px-14 h-px-14"
                src="assets/images/icons/{{ _util.theme !== 'menu_dark' ?  _util.theme.split('_')[1] + '-' + 'grid-white' : 'grid-white'}}.svg">
            </a>
            <p class="module-title m-0 text-ellipsis">apps</p>
          </div>
        </li> -->
      </ng-container>
    </ul>

  </div>

  <div>
    <div class="sidebar-brand" routerLink={{homePage}}>
      <ng-container *ngIf="org?.logo; else orgBadge">
        <img [src]="org.logo" alt="" />
      </ng-container>
      <ng-template #orgBadge>
        <span class="badge badge-org-img cursor-pointer" (click)="showProfileModel()">{{_util.getOrgBadgeName(org?.name
          || "organization")}}</span>
      </ng-template>
    </div>
  </div>

  <!-- #Menu -->
</aside>
<!-- #END# Left Sidebar -->
<div class="slide-card pointer-arrow-left-bottom" *ngIf="!isIconTouched" (appClickOutside)="isIconTouched = true"
  (mouseleave)="isIconTouched = true">
  <div class="top">
    <img class="settings cursor-pointer" src="assets/images/icons/employee-settings.svg">
    <div class="d-grid align-content-center justify-items-center gap-3">
      <label class="hoverable" for="fileInput">
        <img src="assets/images/logo-icon.svg" alt="">
        <div class="hover-text">
          <i class="material-icons">photo_camera</i>
          <input type="file" id="fileInput" accept="image/*">
        </div>
      </label>
      <p>{{ org.name }}</p>
    </div>
  </div>
  <div class="bottom">
    <p class="sml-22 mb-0 font-weight-5 lh-sm font-12 text-center subtitle">Super Admin</p>
    <div class="d-flex justify-content-center">
      <div class="employee-pick"><img class="employee-pick" *ngIf="profile?.badge_url" src="{{ profile?.badge_url }}"
          alt="employee logo"><span *ngIf="!profile?.badge_url">{{
          profile?.first_name?.charAt(0) | titlecase }}</span></div>
      <div class="ms-2">
        <div class="d-flex gap-8 align-items-center">
          <span class="font-weight-5 lh-sm subtitle">{{ profile?.fullname }}
          </span>
          <span class="gray-600 font-weight-5 font-12">{{ profile?.employee_no }}
          </span>
        </div>
        <div class="d-flex gray-600 font-weight-5 font-12 m-0"><span class='font-12 me-1'>
            {{ profile?.employee?.designation?.name ? profile?.employee?.designation?.name : 'N/A'}}</span> <span
            *ngIf="profile?.department?.name">|</span> <span class="font-12 ms-1">{{ profile?.employee?.department?.name
            ? profile?.employee?.department?.name : 'N/A' }}</span></div>
      </div>
    </div>
    <div class="d-flex justify-content-around">
      <div class="d-grid text-center">
        <p class="m-0 gray-600 font-12 font-weight-400">Count</p>
        <p class="m-0 font-12 font-weight-400">{{ '20-30' + ' Person'}}</p>
      </div>
      <div class="d-grid text-center">
        <p class="m-0 gray-600 font-12 font-weight-400">Industry</p>
        <p class="m-0 font-12 font-weight-400">Information & Tech</p>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <p class="m-0 color-secondary font-12 cursor-pointer">Switch to next org >>></p>
    </div>
  </div>
</div>